import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import moment from 'moment';

const VatrateFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});

  const emptyDateTimeViewDate = moment().startOf('day').toDate();

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().vatrateId) || (entity === 'vat-rate' && id)) {
      apiCall('patch', '/api/v2/vat-rate/' + (window.App.urlVars().vatrateId ?? id), newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderVatrateList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/vat-rate', data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderVatrateList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/finance/vat-rate/update/' + response.data.data.id); 
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error p-d-block">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }
  // const toolbarOptions = {
  //   container: [
  //     [{'header': [1, 2, 3, 4, 5, 6, false]}],
  //     ['bold', 'italic', 'underline', 'strike'],
  //     ['image', 'formula'],
  //     [{'align': []}],

  //     [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
  //     [{'script': 'sub'}, {'script': 'super'}],
  //     [{'indent': '-1'}, {'indent': '+1'}],
  //     [{'color': []}, {'background': []}],
  //     ['clean']
  //   ]
  // }

  useEffect(() => {
    if (!Boolean(window.App.urlVars().vatrateId) || (entity === 'vat-rate' && id)) {
      setFormData(prev => ({
        ...prev,
        country_code: prev.country_code || process.env.REACT_APP_DEFAULT_COUNTRY
      }));
    }
    if ((!window.App.urlVars().create && window.App.urlVars().vatrateId) || (entity === 'vat-rate' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/vat-rate/' + (window.App.urlVars().vatrateId ?? id))
        .then(response => {
          setFormData(response.data.data || response.data || []);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"vat-rate-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className="p-grid">
              <div className="p-col-12 p-lg-6">
                <Field name="label" render={({ input, meta }) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="label" className={classNames({ 'p-error': isFormFieldValid(meta) })}>{props.t('fieldName')}</label>
                    <InputText id="label" {...input}
                      value={formData.label || ''}
                      onChange={(e) => {
                        setFormData({ ...formData, label: e.target.value });
                        setNewFormData({ ...newFormData, label: e.target.value });
                      }}
                      className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                    />
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>

              <div className="p-col-12 p-lg-6">
                <Field name="country_code" render={({ input, meta }) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="country_code" className={classNames({ 'p-error': isFormFieldValid(meta) })}>{props.t('fieldCountry')}</label>
                    <InputText id="country_code" {...input}
                      value={formData.country_code || ''}
                      onChange={(e) => {
                        const v = e.target.value.toUpperCase();
                        setFormData({ ...formData, country_code: v });
                        setNewFormData({ ...newFormData, country_code: v });
                      }}
                    />
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>

              <div className="p-col-12 p-lg-6">
                <Field name="percentage" render={({ input, meta }) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="percentage" className={classNames({ 'p-error': isFormFieldValid(meta) })}>{props.t('fieldPercentage')}</label>
                    <InputText id="percentage" {...input}
                      value={formData.percentage ?? ''}
                      onChange={(e) => {
                        const raw = e.target.value;
                        const normalized = raw.replace(',', '.').trim();

                        setFormData(prev => ({ ...prev, percentage: raw }));

                        if (normalized === '' || isNaN(Number(normalized))) {
                          input.onChange('');
                          setNewFormData(({ percentage, ...rest }) => rest);
                          } else {
                            const num = Number(normalized);
                            input.onChange(num); 
                            setNewFormData(prev => ({ ...prev, percentage: num }));
                          }
                      }}
                      className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                    />
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>

              <div className="p-col-12 p-lg-6">
                <Field name="rate_type" render={({ input, meta }) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="rate_type" className={classNames({ 'p-error': isFormFieldValid(meta) })}>{props.t('fieldType')}</label>
                    <InputText id="rate_type" {...input}
                      value={formData.rate_type || ''}
                      onChange={(e) => {
                        setFormData({ ...formData, rate_type: e.target.value });
                        setNewFormData({ ...newFormData, rate_type: e.target.value });
                      }}
                      placeholder={t('vatPercentageExamplePlaceholder')}
                    />
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>


              <div className="p-col-12 p-lg-6">
                <Field name="vat_code" render={({ input, meta }) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="vat_code" className={classNames({ 'p-error': isFormFieldValid(meta) })}>{props.t('fieldCode')}</label>
                    <InputText id="vat_code" {...input}
                      value={formData.vat_code || ''}
                      onChange={(e) => {
                        setFormData({ ...formData, vat_code: e.target.value });
                        setNewFormData({ ...newFormData, vat_code: e.target.value });
                      }}
                      placeholder={t('vatCodeExamplePlaceholder')}
                    />
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>

              <div className="p-col-12">
                <Field name="description" render={({ input, meta }) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="description" className={classNames({ 'p-error': isFormFieldValid(meta) })}>{props.t('fieldDescription')}</label>
                    <InputTextarea id="description" rows={3} {...input}
                      value={formData.description || ''}
                      onChange={(e) => {
                        setFormData({ ...formData, description: e.target.value });
                        setNewFormData({ ...newFormData, description: e.target.value });
                      }}
                    />
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>

              <div className="p-col-12 p-lg-6">
                <Field name="valid_from" render={({ input, meta }) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="valid_from" className={classNames({ 'p-error': isFormFieldValid(meta) })}>{props.t('fieldValidFrom')}</label>
                    <Calendar id="valid_from" showTime dateFormat="yy-mm-dd"
                      value={formData.valid_from || null}
                      viewDate={!formData.valid_from ? emptyDateTimeViewDate : null}
                      onChange={(e) => {
                        const selectedValue = !formData.valid_from && e.value ? moment(e.value).startOf('day').toDate() : e.value;
                        setFormData({ ...formData, valid_from: selectedValue });
                        setNewFormData({
                          ...newFormData,
                          valid_from: selectedValue ? moment(selectedValue).format('YYYY-MM-DD HH:mm:ss') : null
                        });
                      }}
                    />
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>

              <div className="p-col-12 p-lg-6">
                <Field name="valid_to" render={({ input, meta }) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="valid_to" className={classNames({ 'p-error': isFormFieldValid(meta) })}>{props.t('fieldValidTo')}</label>
                    <Calendar id="valid_to" showTime dateFormat="yy-mm-dd"
                      value={formData.valid_to || null}
                      viewDate={!formData.valid_to ? emptyDateTimeViewDate : null}
                      onChange={(e) => {
                        const selectedValue = !formData.valid_to && e.value ? moment(e.value).startOf('day').toDate() : e.value;
                        setFormData({ ...formData, valid_to: selectedValue });
                        setNewFormData({
                          ...newFormData,
                          valid_to: selectedValue ? moment(selectedValue).format('YYYY-MM-DD HH:mm:ss') : null
                        });
                      }}
                    />
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            </div>

          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'vat-rate' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(VatrateFormComponent);
